import { Buyer } from '~/models/marketplace/buyer'
import { CartSellerInfo } from '~/models/marketplace/cart'
import { Pagination } from '~/models/search/types'
import { Order } from '~/models/marketplace/order'
import { SchemaField } from '~/models/form/types'

export enum MarketplaceReviewType {
  QUALITY = 'quality',
  SUPPORT = 'support',
  DELIVERY = 'delivery'
}

export interface MarketplaceReviewReply {
  comment: string
  id: number
  reviewId: number
  created: number
}

export interface MarketplaceReview {
  created: number
  deleted: boolean
  modified: number
  deliveryRating: number
  qualityRating: number
  supportRating: number
  averageRating: number
  likes: number
  buyer: Buyer
  isPublic: boolean
  isEditable: boolean
  userLiked: boolean
  reply?: MarketplaceReviewReply
  seller: CartSellerInfo
  id: number
  comment?: string
  mostRecentOrder?: Order
}

export interface ReviewsResult {
  recentOrders?: Order[]
  reviews: {
    pagination: Pagination
    rows: MarketplaceReview[]
  }
}

export interface ReviewResult {
  review: MarketplaceReview
}

export interface SellerReviewForm {
  comment?: string
  supportRating: number
  deliveryRating: number
  qualityRating: number
}

export interface ReviewFormResult {
  values: SellerReviewForm
}
export interface ReviewFormSchemaResult {
  sellerReview?: SellerReviewForm
  schema: SchemaField
  seller: CartSellerInfo
}

export interface SellerReviewReplyForm {
  comment: string
}

export interface ReviewReplyFormResult {
  values: SellerReviewReplyForm
}

export interface ReviewReplyFormSchemaResult {
  reply?: SellerReviewReplyForm
  schema: SchemaField
}

export interface ReviewApproveResult {
  review: SellerReviewForm
}

export enum MarketplaceReviewReportReasons {
  FAKE = 'fake',
  INSULT = 'insult'
}
